import React, { useEffect, useState, useCallback } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { get } from "lodash";
import { useHistory } from "react-router-dom";
import infoIcon from "../../../images/ic_info.png";
import { Range } from "react-range";

function UpdatePatient(props) {
  const navigate = useHistory();
  const [formData, setName] = useState({
    CaseName: "",
    // CaseDescription: "",
    PatientName: "",
    // AssessmentBlueprint: "",
    DateOfBirth: "",
    PatientRole: "",
    UserRole: "",
    Address: "",
    Place: "",
    PersonalLife: "",
    PresentingProblem: "",
    AboutTheCase: "",
  });
  const [Gender, setGender] = useState("");
  const [Patientid, getPatientid] = useState("");
  const UserRole = localStorage.getItem("URole");
  const ManagID = localStorage.getItem("ManegerId");

  const PtId = localStorage.getItem("PatientId");
  const [PortalList, setPortalList] = useState([]);
  const [PoralId, setPortalId] = React.useState("");
  const [selectPortal, setselectPortal] = useState([]);
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [EnvironmentId, setEnvironmentId] = React.useState("");
  const [CharacterId, setCharacterId] = React.useState("");
  const [EnvironmentImgPreview, setEnvironmentImgPreview] = React.useState("");
  const [CharacterImgPreview, setCharacterImgPreview] = React.useState("");

  const [prompt, setPrompt] = React.useState("");
  const [EnvBgImgList, setEnvBgImgList] = useState([]);
  const [custBgImgFile, setCustBgImgFile] = useState(null);
  const [error, setError] = useState('');
  const [selectedEnvBg, setSelectedEnvBg] = useState({
    Img_Id: 0,
    Img_Url: "",
    Img_Name: ""
  });
  const [choosedEnvBg, setChoosedEnvBg] = useState({
    Img_Id: 0,
    Img_Url: "",
    Img_Name: ""
  });
  const [isEnvGenerating, setIsEnvGenerating] = useState(false);
  const [isFinalSubmitting, setIsFinalSubmitting] = useState(false);
  const [custBgLimit, setCustBgLimit] = useState('');
  const [custBgRemaining, setCustBgRemaining] = useState('');
  const [CustEnvImgPreview, setCustEnvImgPreview] = React.useState("");
  const [generatedImages, setGeneratedImages] = useState([]);
  const [values, setValues] = useState([1]);
  const [EHRRecord, setEHRRecord] = useState([])
  const [physicalExam, setPhysicalExam] = useState([]);
  const [vitalSign, setVitalSign] = useState([]);
  const [imagePreviewVisible, setImagePreviewVisible] = useState({});
  var [ehrData, setEhrData] = useState(false);
  const [showAllSections, setShowAllSections] = useState(false);
  const [VoiceList, setVoiceList] = useState([]);
  const [VoiceId, setVoiceId] = React.useState("");


  const handleSliderChange = (newValues) => {
    setValues(newValues);
  };

  const handleShowAllToggle = () => {
    // console.log("data", ehrData)
    setEhrData(!ehrData);
  };

  useEffect(() => {
    LoadPatient();
    LoadPortals();
    LoadCustBgLimit();
    LoadCharacterVoices();

    // Function to handle browser back button navigation
    const unlisten = navigate.listen((location, action) => {
      if (action === 'POP') {
        const modalElement = document.getElementsByClassName("modal-backdrop");
        if (modalElement) {
          Array.from(modalElement).forEach(element => {
            element.style.display = 'none';
          });
        }
      }
    });

    return () => {
      unlisten();
    };
  }, [navigate]);

  const LoadCharacterVoices = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllVoice`).then((res) => {
      setVoiceList(res.data);
    });
  };
  const handleChangeVoice = (event) => {
    let id = event.target.value;
    if (id !== "") {
      setVoiceId(id);
    } else {
      setVoiceId("");
    }
  }

  const LoadPatient = () => {
    const datavalue = {
      id: PtId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getNewPatientByid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      console.log("data needed", res.data.result)
      setName({
        CaseName: res.data.result.Case_Name,
        PatientName: res.data.result.Patient_Name,
        DateOfBirth: res.data.result.DOB,
        PatientRole: res.data.result.Character_Role,
        UserRole: res.data.result.User_Role,
        Address: res.data.result.Address,
        Place: res.data.result.Place,
        PersonalLife: res.data.result.Personal_Life,
        PresentingProblem: res.data.result.Presenting_Problem,
        AboutTheCase: res.data.result.About_The_Case,
        Skill1: res.data.result.Skill1,
        Skill2: res.data.result.Skill2,
        Skill3: res.data.result.Skill3,
        Skill4: res.data.result.Skill4,
        Skill5: res.data.result.Skill5,
        // Skill6: res.data.result.Skill6,
        Skill6: "",
        SkillDesc1: res.data.result.SkillDesc1,
        SkillDesc2: res.data.result.SkillDesc2,
        SkillDesc3: res.data.result.SkillDesc3,
        SkillDesc4: res.data.result.SkillDesc4,
        SkillDesc5: res.data.result.SkillDesc5,
        // SkillDesc6: res.data.result.SkillDesc6,
        SkillDesc6: "",
        EHR_Records: res.data.result.EHR_Records,
        PhysicalExams: res.data.result.PhysicalExams,
        VitalSigns: res.data.result.VitalSigns,
      });
      setEhrData(res.data.result.Show_Ehr_Data);
      setEHRRecord(res.data.result.EHR_Records)
      setPhysicalExam(res.data.result.PhysicalExams)
      setVitalSign(res.data.result.VitalSigns)
      setGender(res.data.result.Patient_Gender);
      getPatientid(res.data.result.Patient_Id);
      setselectPortal(res.data.result.Portal_Id);
      setPortalId(res.data.result.Portal_Id);
      setVoiceId(res.data.result.Voice_Id);

      setEnvironmentId(res.data.result.Environment_Id);
      setCharacterId(res.data.result.Character_Id);
      LoadEnvironmentImg(res.data.result.Environment_Id);
      LoadCharacterImg(res.data.result.Character_Id);

      LoadEnvironments(res.data.result.Portal_Id);
      LoadCharacters(res.data.result.Portal_Id);

      LoadEnvBgImages(res.data.result.Portal_Id);

      if (res.data.result.envBgImgModel.Img_Url !== "") {
        setCustEnvImgPreview(res.data.result.envBgImgModel.Img_Url);
        var img = document.getElementById("custEnvImgPreview");
        img.style.visibility = "visible";
        img.style.width = "100%";
        img.style.height = "auto";
      }

      setChoosedEnvBg({
        Img_Id: res.data.result.envBgImgModel.Img_Id,
        Img_Name: res.data.result.envBgImgModel.Img_Name,
        Img_Url: res.data.result.envBgImgModel.Img_Url,
      });
    });
  };

  const LoadEnvBgImages = (portalId) => {
    const datavalue = {
      portalId: portalId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetEnvBgImagesByPortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      setEnvBgImgList(res.data.data);
    });
  };

  const LoadPortals = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`).then((res) => {
      setPortalList(res.data);
    });
  };

  const LoadCustBgLimit = () => {
    if (UserRole === "Manager") {
      const datavalue = {
        ManagerId: ManagID,
      };

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/GetCustBgLimit`,
        data: datavalue,
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios(authOptions).then((res) => {
        setCustBgLimit(res.data.data.limit);
        setCustBgRemaining(res.data.data.remaining);
      });
    }
  }

  const handleChangePortal = (event) => {
    setPortalId(event.target.value);
    setselectPortal(event.target.value);
  };

  const LoadEnvironments = (portalId) => {
    const datavalue = {
      portalId: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetEnvironmentByPortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setEnvironmentList(res.data.data);
    });
  };

  const LoadCharacters = (portalId) => {
    const datavalue = {
      portalId: portalId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCharacterByPortal`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setCharacterList(res.data.data);
    });
  };

  const handleChangeEnvironment = (event) => {
    let env_id = event.target.value
    setEnvironmentId(env_id);
    LoadEnvironmentImg(env_id);
  };

  function LoadEnvironmentImg(env_id) {
    if (env_id != "") {
      var imagepath = `${process.env.REACT_APP_API_URL}/GetEnvironmentImageById?EnvironmentId=` + env_id;
      setEnvironmentImgPreview(imagepath);
      var img = document.getElementById("envImgPreview")
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  }

  const handleChangeCharacter = (event) => {
    let character_id = event.target.value
    setCharacterId(character_id);
    LoadCharacterImg(character_id);
  };

  function LoadCharacterImg(character_id) {
    if (character_id != "") {
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview(imagepath);
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      // img.style.maxHeight = "150px";
      img.style.height = "auto";
    } else {
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  }

  const Patientsubmit = async (e) => {
    e.preventDefault();
    let formDataSet = new FormData();
    //formdata object
    if (
      PoralId == "" ||
      formData.CaseName === "" ||
      formData.PatientName === "" ||
      formData.DateOfBirth === "" ||
      Gender === "" ||
      formData.PatientRole === "" ||
      formData.UserRole === "" ||
      formData.Address === "" ||
      formData.Place === "" ||
      formData.PersonalLife === "" ||
      formData.PresentingProblem === "" ||
      EnvironmentId == "" ||
      CharacterId == ""
    ) {
      if (EnvironmentId == "") {
        Swal.fire({
          title: "Error",
          text: "Please select at least one environment.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (CharacterId == "") {
        Swal.fire({
          title: "Error",
          text: "Please select at least one character.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (PoralId === "") {
        Swal.fire({
          title: "Error",
          text: "Please select portal.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.CaseName === "") {
        Swal.fire({
          title: "Error",
          text: "Case name is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.PatientName === "") {
        Swal.fire({
          title: "Error",
          text: "Character's name is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.DOB === "") {
        Swal.fire({
          title: "Error",
          text: "Date of birth is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (Gender === "") {
        Swal.fire({
          title: "Error",
          text: "Select gender.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.PatientRole === "") {
        Swal.fire({
          title: "Error",
          text: "Character's role is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.UserRole === "") {
        Swal.fire({
          title: "Error",
          text: "User's role is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.Address === "") {
        Swal.fire({
          title: "Error",
          text: "Address is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.Place === "") {
        Swal.fire({
          title: "Error",
          text: "Scenario location is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.PersonalLife === "") {
        Swal.fire({
          title: "Error",
          text: "Personal life is Required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
      if (formData.PresentingProblem === "") {
        Swal.fire({
          title: "Error",
          text: "Case description is required.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1e2b38"
        });
      }
    } else {
      const formDataSet = new FormData();
      const datavalue = {
        Id: PtId,
        Patient_id: Patientid,
        User_Id: ManagID,
        Portal_Id: PoralId == "" ? selectPortal : PoralId,
        Environment_Id: EnvironmentId,
        Character_Id: CharacterId,
        Case_Name: formData.CaseName.charAt(0).toUpperCase() + formData.CaseName.slice(1),
        Patient_Name: formData.PatientName,
        DOB: formData.DateOfBirth,
        Patient_Gender: Gender,
        Character_Role: formData.PatientRole,
        User_Role: formData.UserRole,
        Address: formData.Address,
        Place: formData.Place,
        Personal_Life: formData.PersonalLife,

        Presenting_Problem: formData.PresentingProblem,
        About_The_Case: formData.AboutTheCase,
        Skill1: formData.Skill1,
        Skill2: formData.Skill2,
        Skill3: formData.Skill3,
        Skill4: formData.Skill4,
        Skill5: formData.Skill5,
        // Skill6: formData.Skill6,
        Skill6: "",
        SkillDesc1: formData.SkillDesc1,
        SkillDesc2: formData.SkillDesc2,
        SkillDesc3: formData.SkillDesc3,
        SkillDesc4: formData.SkillDesc4,
        SkillDesc5: formData.SkillDesc5,
        // SkillDesc6: formData.SkillDesc6,
        SkillDesc6: "",
        Voice_Id: VoiceId === "" ? "0" : VoiceId,
        EHR_Records: EHRRecord,
        PhysicalExams: physicalExam,
        VitalSigns: vitalSign,
        Show_Ehr_Data: ehrData
      };

      if (choosedEnvBg.Img_Url !== "") {
        datavalue.envBgImgModel = choosedEnvBg;
      }
      formDataSet.append('data', JSON.stringify(datavalue));
      physicalExam.forEach((exam, index) => {
        if (exam.image) {
          formDataSet.append(`phyExamImage_${index}`, exam.image);
        }
      });

      // Extract token from localStorage.state
      let token = null;
      try {
        const raw = localStorage.getItem("state");
        if (raw) {
          const state = JSON.parse(raw);
          token = state.auth?.token;
        }
      } catch (e) {
        console.error("Token parsing failed", e);
      }

      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/updateNewPatientByid`,
        data: formDataSet,
        headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
        json: true,
      };

      setIsFinalSubmitting(true);

      axios(authOptions)
        .then((res) => {
          setIsFinalSubmitting(false);

          if (res.data.ExpResult) {
            Swal.fire({
              title: "Failed",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else if (res.data.SuccessResult) {
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
            }).then(function () {
              UserRole === "Admin"
                ? navigate.push("/CaseList")
                : navigate.push("/ManagerPatientList");
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "An error occured!",
              icon: "error",
              confirmButtonText: "Ok",
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const BackFunc = () => {
    UserRole === "Admin"
      ? navigate.push("/CaseList")
      : navigate.push("/ManagerPatientList");
  };

  const handleChangeDrp = (event) => {
    setGender(event.target.value);
  };
  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddNewEHR = () => {
    const newRecord = { Heading: "", Description: "" };
    setEHRRecord([...EHRRecord, newRecord]);
  };
  const handleDeleteEHR = (index) => {
    const updatedRecords = EHRRecord.filter((_, i) => i !== index);
    setEHRRecord(updatedRecords);
  };
  const handleAddNewPhysicalExam = () => {
    const newExam = { Heading: "", Description: "", ImageUrl: null };
    setPhysicalExam([...physicalExam, newExam]);
  };
  const handleDeletePhysicalExam = (index) => {
    const updatedExam = physicalExam.filter((_, i) => i !== index);
    setPhysicalExam(updatedExam);
  };
  const handleAddNewVitalSign = () => {
    const newVital = { Heading: "", Description: "" };
    setVitalSign([...vitalSign, newVital]);
  };
  const handleDeleteVitalSign = (index) => {
    const updatedVital = vitalSign.filter((_, i) => i !== index);
    setVitalSign(updatedVital);
  };
  const handleImagePhyExam = (event, index) => {
    const updatedSkills = [...physicalExam];
    const file = event.target.files[0];
    updatedSkills[index].image = file;
    console.log("image pe", updatedSkills)
    setPhysicalExam(updatedSkills);
  };


  const handleChangeNew = (e, type, index) => {
    console.log("change clicked");
    const { name, value } = e.target;
    console.log("value", e.target)
    if (type === "EHRRecord") {
      const updatedEHR = [...EHRRecord];
      updatedEHR[index] = { ...updatedEHR[index], [name]: value };
      console.log("updated EHR", updatedEHR)
      setEHRRecord(updatedEHR);
    } else if (type === "PhysicalExam") {
      const updatedExam = [...physicalExam];
      updatedExam[index] = { ...updatedExam[index], [name]: value };
      console.log("updated PE", updatedExam)
      setPhysicalExam(updatedExam);
    } else if (type === "VitalSign") {
      const updatedVitalSign = [...vitalSign];
      updatedVitalSign[index] = { ...updatedVitalSign[index], [name]: value };
      console.log("updated VITAL Sign", updatedVitalSign)
      setVitalSign(updatedVitalSign);
    }
  };

  const toggleImagePreview = (index) => {
    setImagePreviewVisible((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const onCustBgImgUpload = (event) => {
    const uFile = get(event, "target.files[0]");
    if (uFile && uFile.type.startsWith('image/')) {
      const maxSize = 20 * 1024 * 1024; // 5MB

      if (uFile.size > maxSize) {
        setError('Please drop an image file less than 20MB');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
      } else {
        setCustBgImgFile(uFile);
        setError('');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-circle-check'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'File Dropped Successfully!';
      }
    } else {
      setError('Please select an image file (e.g., .jpg, .png)');

      var fileUploadIcon = document.getElementById("fileUploadIcon");
      fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

      var fileUploadHeader = document.getElementById("fileUploadHeader");
      fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
    }
  };

  const onChooseClicked = () => {
    if (selectedEnvBg.Img_Url === "") {
      setError('Please select an image');
      return;
    }

    setCustBgImgFile(null); // Clear the custom image file
    setError(''); // Clear the error message

    setCustEnvImgPreview(selectedEnvBg.Img_Url); // Set the selected image as the background image
    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "visible";
    img.style.width = "100%";
    img.style.height = "auto";

    setChoosedEnvBg(selectedEnvBg); // Set the selected image as the choosed image
  }

  const onRemoveClicked = () => {
    setCustEnvImgPreview(''); // Clear the custom image preview
    setChoosedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the choosed image

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";

    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    var img3 = document.getElementById("img3");
    var img4 = document.getElementById("img4");
    img1.style.border = "1px solid #ccc";
    img2.style.border = "1px solid #ccc";
    img3.style.border = "1px solid #ccc";
    img4.style.border = "1px solid #ccc";
  }

  const onCancelClicked = () => {
    setCustEnvImgPreview(''); // Clear the custom image preview
    setSelectedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the selected image
    setChoosedEnvBg({
      Img_Id: 0,
      Img_Url: "",
      Img_Name: ""
    }); // Clear the choosed image
    setPrompt('');
    // setEnvBgImgList([]);
    setCustBgImgFile(null); // Clear the custom image file
    setError(''); // Clear the error message
    setGeneratedImages([]);

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "hidden";
    img.style.width = "0px";
    img.style.height = "0px";

    var img1 = document.getElementById("img1");
    var img2 = document.getElementById("img2");
    var img3 = document.getElementById("img3");
    var img4 = document.getElementById("img4");
    img1.style.border = "1px solid #ccc";
    img2.style.border = "1px solid #ccc";
    img3.style.border = "1px solid #ccc";
    img4.style.border = "1px solid #ccc";
  }

  const onUploadClicked = () => {
    if (!custBgImgFile) {
      setError('Please select an image file (e.g., .jpg, .png)');
      return;
    }

    if (PoralId === "") {
      setError('Please select a portal first');
      return;
    }

    let formDataSet = new FormData();
    formDataSet.append("prompt", prompt);
    formDataSet.append("img", custBgImgFile);
    formDataSet.append("portalId", PoralId);
    formDataSet.append("ManagerId", "0");
    formDataSet.append("UserRole", UserRole ? UserRole : "");

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GenerateEnvBg`,
      data: formDataSet,
      headers: { "Content-Type": "multipart/form-data" },
    };

    setError(''); // Clear the error message
    setIsEnvGenerating(true); // Show the loading animation

    axios(authOptions).then((res) => {
      setIsEnvGenerating(false); // Hide the loading animation
      if (res.data.ExpResult) {
        setError(res.data.ExpResult);
      } else if (res.data.SuccessResult) {
        var images = res.data.SuccessResult.split(","); // Split the string into an array with 4 elements
        setGeneratedImages(images);
      } else {
        setError("An Error Occured");
      }
    }).catch((error) => {
      setIsEnvGenerating(false); // Hide the loading animation
      setError('An error occured!');
      console.log("error occur", error);
    }
    );
  }

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();

    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-download'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drop your file here!';
  };

  const onDragLeave = (e) => {
    e.preventDefault();

    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
  };

  const removeFileButton = () => {
    setCustBgImgFile(null);
    setError('');

    var customBgImg = document.getElementById("customBgImg");
    customBgImg.value = '';


    var fileUploadIcon = document.getElementById("fileUploadIcon");
    fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

    var fileUploadHeader = document.getElementById("fileUploadHeader");
    fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
  }


  const onDrop = useCallback((e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      if (files.length > 1) {
        setError('Please drop only one image file (e.g., .jpg, .png)');

        var fileUploadIcon = document.getElementById("fileUploadIcon");
        fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

        var fileUploadHeader = document.getElementById("fileUploadHeader");
        fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
      } else {
        const droppedFile = files[0];

        if (droppedFile.type.startsWith('image/')) {
          const maxSize = 20 * 1024 * 1024; // 20MB

          if (droppedFile.size > maxSize) {
            setError('Please drop an image file less than 5MB');

            var fileUploadIcon = document.getElementById("fileUploadIcon");
            fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

            var fileUploadHeader = document.getElementById("fileUploadHeader");
            fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
          } else {
            setCustBgImgFile(droppedFile);
            setError('');

            var fileUploadIcon = document.getElementById("fileUploadIcon");
            fileUploadIcon.innerHTML = "<i class='fa-solid fa-circle-check'></i>";

            var fileUploadHeader = document.getElementById("fileUploadHeader");
            fileUploadHeader.innerHTML = 'File Dropped Successfully!';
          }
        } else {
          setError('Please drop an image file (e.g., .jpg, .png)');

          var fileUploadIcon = document.getElementById("fileUploadIcon");
          fileUploadIcon.innerHTML = "<i class='fa-solid fa-upload'></i>";

          var fileUploadHeader = document.getElementById("fileUploadHeader");
          fileUploadHeader.innerHTML = 'Drag & Drop to Upload File';
        }
      }
    }
  }, []);

  const handlePromptChange = (e) => {
    setPrompt(e.target.value);
  }

  // const handleEnvBgImgClick = (imageUrl, imgName, imgId) => {
  //   setSelectedEnvBg({
  //     img_Id: imgId,
  //     Img_Name: imgName,
  //     Img_Url: imageUrl
  //   });
  // };
  const handleEnvBgImgClick = (imageUrl, imgName, imgId) => {
    setSelectedEnvBg({
      img_Id: imgId,
      Img_Name: imgName,
      Img_Url: imageUrl
    });

    if (imageUrl === "") {
      setError('Please select an image');
      return;
    }

    setCustBgImgFile(null);
    setError('');

    setCustEnvImgPreview(imageUrl);

    var img = document.getElementById("custEnvImgPreview");
    img.style.visibility = "visible";
    img.style.width = "100%";
    img.style.height = "auto";

    setChoosedEnvBg({
      img_Id: imgId,
      Img_Name: imgName,
      Img_Url: imageUrl
    });
    const closeButton = document.querySelector('#EnvBgImgLibraryModal [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click();
    }
  };

  const handleChangeEnvBgImgName = (event) => {
    setChoosedEnvBg((prevState) => ({
      ...prevState,          // Spread the previous state to retain the other properties
      Img_Name: event.target.value   // Update only the Img_Name property
    }));
  }

  return (
    <>
      <div className="page-content-wrapper">

        {/* Custom Background Upload Modal */}
        <div class="modal fade" style={{ top: "30px", left: "25px" }} id="uploadImageModal" tabindex="-1" aria-labelledby="uploadImageModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-fullscreen" style={{ width: "98%", height: "95%" }}>
            <div class="modal-content" style={{ paddingRight: "10px" }}>
              <div class={UserRole == "Manager" ? "modal-header row" : "modal-header"}>
                {UserRole == "Manager" &&
                  <div className="d-flex justify-content-center">
                    <span style={{ color: "red", fontSize: "18px", fontWeight: "600" }}>Limit: {custBgRemaining} / {custBgLimit}</span>
                  </div>
                }

                <div class="d-flex justify-content-between align-items-center">
                  <h1 class="modal-title fs-5" style={{ margin: "0", marginLeft: "10px", fontWeight: "600" }} id="uploadImageModalLabel">Upload Custom Environment Background</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

              </div>
              <div class="modal-body">
                <div className="row d-flex justify-content-center">
                  <div className="col-sm-2">
                    <h4 style={{ textAlign: "end", margin: "0px", marginTop: "5px", fontWeight: "500" }}>Prompt : </h4>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      value={prompt}
                      onChange={handlePromptChange}
                      name="prompt"
                      className="form-control"
                      id="prompt"
                      disabled={(isEnvGenerating || generatedImages.length > 0)}
                      placeholder="make it more realistic with good lighting"
                    />
                  </div>
                </div>
                <hr style={{ height: "2px", background: "#711a1a73" }} />
                <div className="row d-flex justify-content-center">

                  {isEnvGenerating &&
                    <>
                      {/* Loading Animation Starts */}
                      <div className="col-sm-6 d-flex justify-content-center" style={{ marginTop: "150px" }}>
                        <div class="device" style={{ fontSize: "30px" }}>
                          <div class="device__a" style={{ backgroundColor: "#abafba" }}>
                            <div class="device__a-1" style={{ backgroundColor: "#000" }}></div>
                            <div class="device__a-2" style={{ backgroundColor: "#000" }}></div>
                          </div>
                          <div class="device__b" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__c" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__d" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__e" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__f" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__g" style={{ backgroundColor: "#abafba" }}></div>
                        </div>
                      </div>
                      {/* Loading Animation Ends */}
                    </>
                  }

                  {(!isEnvGenerating && generatedImages.length < 1) &&
                    <>

                      <div className="col-sm-6">
                        {error && <h4 style={{ textAlign: "center", margin: "0px", marginTop: "5px 0 20px 0", fontWeight: "500", color: "red" }}>{error}</h4>}

                        <div
                          class="drag-area"
                          style={{ paddingBottom: "30px", paddingTop: "50px" }}
                          onDragOver={onDragOver}
                          onDrop={onDrop}
                          onDragEnter={onDragOver}
                          onDragLeave={onDragLeave}>
                          <div id="fileUploadIcon"><i class="fa-solid fa-upload"></i></div>
                          <header id="fileUploadHeader">Drag & Drop to Upload File</header>
                          <span>OR</span>
                          <label htmlFor="customBgImg" style={{ cursor: 'pointer' }}>Select an image</label>
                          <input
                            type="file"
                            onChange={onCustBgImgUpload}
                            id="customBgImg"
                            name="customBgImg"
                            accept="image/*"
                            hidden />
                        </div>
                      </div>

                      <div className="row row d-flex justify-content-center">
                        <div className="col-sm-6">
                          <div className="d-flex justify-content-center">
                            {
                              custBgImgFile &&
                              <h4
                                style={{ textAlign: "center", margin: "0px", marginTop: "20px", fontWeight: "500", color: "#f7fff7", backgroundColor: "#7b2cbf", padding: "5px 20px 5px 20px", borderRadius: "50px" }}>
                                <span>{custBgImgFile.name}</span>
                                <span style={{ marginLeft: "10px", marginRight: "10px" }}> | </span>
                                <span>{(custBgImgFile.size / (1024 * 1024)).toFixed(2)} MB</span>
                                <span onClick={removeFileButton} style={{ marginLeft: "50px", cursor: "pointer" }}><i class="fa-solid fa-trash"></i></span>
                              </h4>}
                          </div>
                          <div className="mt-5">
                            <ul>
                              <li>
                                <span style={{ fontStyle: "italic" }}>Make sure the uploaded image resembles the selected <b>Environment</b>.</span>
                              </li>
                              <li>
                                <span style={{ fontStyle: "italic" }}>Enter specific prompts in the <b>Prompt</b> field to get the desired background.</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  }

                </div>

                {(!isEnvGenerating && generatedImages.length > 0) &&
                  <>
                    <div className="row d-flex justify-content-center">
                      {generatedImages.map((imageUrl, index) => (
                        <div className="col-sm-5 my-2" key={index}>
                          <img
                            src={imageUrl}
                            onClick={() => handleEnvBgImgClick(imageUrl, "", 0)}

                            style={{
                              width: "100%",
                              height: "auto",
                              cursor: "pointer",
                              margin: "5px",
                              borderRadius: "5px",
                              border: selectedEnvBg.Img_Url === imageUrl ? "5px solid blue" : "1px solid #ccc",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </>
                }

              </div>
              <div class="modal-footer">
                {!isEnvGenerating && generatedImages.length < 1 &&
                  <>
                    {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                    <button type="button" onClick={onUploadClicked} class="btn btn-primary">Upload</button>
                  </>
                }

                {!isEnvGenerating && generatedImages.length > 0 &&
                  <>
                    <button type="button" onClick={onCancelClicked} data-bs-dismiss="modal" class="btn btn-secondary">Cancel</button>
                    <button type="button" onClick={onChooseClicked} disabled={!selectedEnvBg.Img_Url} data-bs-dismiss="modal" class="btn btn-primary">Choose</button>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
        {/* Custom Background Modal Ends */}



        {/* Environment Background Images Library Modal Ends */}
        <div class="modal fade" id="EnvBgImgLibraryModal" tabindex="-1" aria-labelledby="EnvBgImgLibraryModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content" style={{ paddingRight: "20px" }}>
              <div className="modal-header">
                <div class="d-flex justify-content-between align-items-center w-100">
                  <h1 class="modal-title fs-5" style={{ margin: "0", marginLeft: "10px", fontWeight: "600" }} id="EnvBgImgLibraryModalLabel">Environment Library</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

              </div>
              <div class="modal-body">
                <div className="row d-flex justify-content-center">
                  {EnvBgImgList.map((imgData, index) => (
                    <div className="col-sm-5 my-2" key={index}>
                      <img
                        src={imgData.img_Url}
                        onDoubleClick={() => handleEnvBgImgClick(imgData.img_Url, imgData.img_Name, imgData.img_Id)}

                        style={{
                          width: "100%",
                          height: "auto",
                          cursor: "pointer",
                          margin: "5px",
                          borderRadius: "5px",
                          border: selectedEnvBg.Img_Url === imgData.img_Url ? "5px solid blue" : "1px solid #ccc",
                        }}
                      />
                    </div>
                  ))}
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                {/* <button type="button" onClick={onChooseClicked} disabled={!selectedEnvBg.Img_Url} data-bs-dismiss="modal" class="btn btn-primary">Choose</button> */}
              </div>
            </div>
          </div>
        </div>
        {/* Environment Background Images Library Modal Ends */}





        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Update Simulation</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block btn-primary"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head d-none">
                  <header>Update Case</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={Patientsubmit}
                  >
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Case ID
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span>{Patientid}</span>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        for="horizontalFormEmail"
                        className="col-sm-3 control-label"
                      >
                        Portal Id
                      </label>
                      <div className="col-sm-9 pt-3">
                        <span className="mt-2">{selectPortal}</span>
                      </div>
                    </div>

                    {/* Case Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="caseName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Case Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CaseName}
                          onChange={handleChange}
                          name="CaseName"
                          className="form-control"
                          id="caseName"
                          placeholder="Enter the name of your case "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    {/* <div className="form-group row">
                      <label
                        htmlFor="caseDescription"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CaseDescription}
                          onChange={handleChange}
                          name="CaseDescription"
                          className="form-control"
                          id="caseDescription"
                          placeholder="Enter Case Description"
                        />
                      </div>
                    </div> */}

                    {/* Patient Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PatientName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PatientName}
                          onChange={handleChange}
                          name="PatientName"
                          className="form-control"
                          id="PatientName"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Patient Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PatientDOB"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={formData.DateOfBirth}
                          onChange={handleChange}
                          name="DateOfBirth"
                          className="form-control"
                          id="PatientDOB"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="gender"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="gender"
                          className="form-control  select2"
                          value={Gender}
                          onChange={handleChangeDrp}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Role"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.PatientRole}
                          onChange={handleChange}
                          name="PatientRole"
                          className="form-control"
                          id="Role"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* User Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="UserRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        User’s Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.UserRole}
                          onChange={handleChange}
                          name="UserRole"
                          className="form-control"
                          id="UserRole"
                          placeholder="Enter the role of the user/learner "
                        />
                      </div>
                    </div>

                    {/* Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Address"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.Address}
                          onChange={handleChange}
                          name="Address"
                          className="form-control"
                          id="Address"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Place of Occurrence */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Place"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario location
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.Place}
                          onChange={handleChange}
                          name="Place"
                          className="form-control"
                          id="Place"
                          placeholder="Enter the location where the scenario is being taking place "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="personalLife"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={formData.PersonalLife}
                          onChange={handleChange}
                          name="PersonalLife"
                          className="form-control"
                          id="personalLife"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc"
                        />
                      </div>
                    </div>

                    {/* Presenting Problem */}
                    <div className="form-group row required">
                      <label
                        htmlFor="presenting_problem"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="presenting_problem"
                          className="form-control"
                          name="PresentingProblem"
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation."
                          style={{ width: "100%", height: "100px" }}
                          value={formData.PresentingProblem}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* TODO: Change Video Link */}
                    <div className="form-group my-5">
                      <span className="fw-bolder">Watch this video before proceeding to generate your own background.</span>
                      <a href="https://vimeo.com/999010516/8d5ad38f87" target="_blank" className="ms-5 btn btn-primary">
                        Click to watch
                      </a>
                    </div>

                    <div className="form-group row required">
                      <label
                        htmlFor="environment"
                        className="col-sm-3 control-label"
                      >
                        Environment
                        <img id="infoToolTip" style={{ width: "22px", paddingLeft: "3px", paddingRight: "3px", paddingBottom: "3px" }} src={infoIcon} />

                        <p>
                          This includes the overall setup of the scene. It is a combination of the physical content (e.g table, counters) and the background.
                        </p>
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="environment"
                          className="form-control select2"
                          onChange={handleChangeEnvironment}
                        >
                          <option value="">--Select--</option>
                          {EnvironmentList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == EnvironmentId ? true : false}>
                                {result.environment_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={EnvironmentImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="envImgPreview"
                              className="previewImg"
                              src={EnvironmentImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Custom Background Starts */}
                    <div className="form-group row">
                      <label
                        htmlFor="customEnvBg"
                        className="col-sm-3 control-label"
                      >
                        Custom Background
                        <img id="infoToolTipCB" style={{ width: "22px", paddingLeft: "3px", paddingRight: "3px", paddingBottom: "3px" }} src={infoIcon} />

                        <p>
                          Contains only the backdrop of the <b>Environment</b>. Will appear behind the physical content of the selected <b>Environment</b>.
                        </p>
                      </label>
                      <div className="col-sm-4">
                        <div className="row mb-3 ms-0 me-0">
                          <button type="button" class="btn col-12" style={{ color: "#FFF", backgroundColor: "#465bd1" }} data-bs-toggle="modal" data-bs-target="#uploadImageModal">
                            Upload Image
                          </button>

                          {EnvBgImgList.length > 0 &&
                            <button type="button" class="btn btn-secondary col-12 mt-3" data-bs-toggle="modal" data-bs-target="#EnvBgImgLibraryModal">
                              Custom Background Library
                            </button>
                          }

                          {CustEnvImgPreview &&
                            <button type="button" class="btn col-12 mt-3" style={{ backgroundColor: "#15bd8c", color: "#000" }} onClick={onRemoveClicked}>
                              Clear Custom Background
                            </button>
                          }

                          {CustEnvImgPreview &&
                            <div className="col-12 mt-3 ps-0 pe-0">
                              <input
                                type="text"
                                placeholder="Enter image name"
                                className="form-control"
                                value={choosedEnvBg.Img_Name}
                                onChange={handleChangeEnvBgImgName} />
                            </div>
                          }

                          {!EnvironmentId &&
                            <>
                              <span className="col-12 mt-2 ps-0"><i>You must select a reference <b>Environment</b> before uploading an image.</i></span>
                            </>
                          }
                        </div>
                      </div>

                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CustEnvImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="custEnvImgPreview"
                              className="previewImg"
                              src={CustEnvImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden"
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* Custom Background Ends */}



                    <div className="form-group row required mt-3">
                      <label
                        htmlFor="character"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character"
                          className="form-control select2"
                          onChange={handleChangeCharacter}
                        >
                          <option value="">--Select--</option>
                          {CharacterList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == CharacterId ? true : false}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                        <div className="col-sm-12 d-flex justify-content-center">
                          <a href={CharacterImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                              id="characterImgPreview"
                              className="previewImg"
                              src={CharacterImgPreview}
                              style={{
                                objectFit: "contain",
                                visibility: "hidden",
                              }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Custom Voice ID List */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Voice"
                        className="col-sm-3 control-label"
                      >
                        Character's Voice
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Voice"
                          className="form-control select2"
                          onChange={handleChangeVoice}
                        >
                          <option value="">--Select--</option>
                          {VoiceList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id} selected={result.id == VoiceId ? true : false}>
                                {result.voice_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label
                        className="col-sm-3 control-label"
                      >
                      </label>
                      <div className="col-sm-9 d-flex justify-content-center">
                      <a href={CharacterImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                            id="characterImgPreview"
                            className="previewImg"
                                src={CharacterImgPreview}
                                style={{
                                    width: "150px",
                                    maxHeight: "150px",
                                    objectFit: "contain",
                                    visibility: "hidden",
                                }}
                            />
                        </a>
                      </div>
                      </div> */}

                    {/* Assessment Blueprint */}
                    {/* <div className="form-group row required">
                      <label
                        htmlFor="assessmentBlueprint"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="assessmentBlueprint"
                          className="form-control"
                          name="AssessmentBlueprint"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.AssessmentBlueprint}
                          onChange={handleChange}
                        />
                      </div>
                    </div> */}


                    <div className="form-group my-5">
                      <span className="fw-bolder">Watch this video to know more about Assessment Blueprint.</span>
                      <a href="https://vimeo.com/1012308813" target="_blank" className="ms-5 btn btn-primary">
                        Click to watch
                      </a>
                    </div>

                    {/* Assessment Blueprint */}
                    <div className="form-group row required">
                      <label
                        htmlFor="assessmentBlueprint"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-sm-4">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill1" value={formData.Skill1} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc1" value={formData.SkillDesc1} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill2" value={formData.Skill2} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc2" value={formData.SkillDesc2} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill3" value={formData.Skill3} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc3" value={formData.SkillDesc3} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill4" value={formData.Skill4} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc4" value={formData.SkillDesc4} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill5" value={formData.Skill5} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc5" value={formData.SkillDesc5} onChange={handleChange} />
                          </div>

                          <div className="col-sm-4 mt-3 d-none">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill6" value={formData.Skill6} onChange={handleChange} />
                          </div>
                          <div className="col-sm-8 mt-3 d-none">
                            <input type="text" placeholder="Enter the description of the competency being assessed. " className="form-control" name="SkillDesc6" value={formData.SkillDesc6} onChange={handleChange} />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Emotion Range  */}

                    {/* <div className="form-group row required">
                      <label className="control-label">Emotion Range</label>
                      <Range
                        step={1}        
                        min={1}
                        max={10}
                        values={values}
                        onChange={handleSliderChange}
                        renderTrack={({ props, children }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: '8px',
                              backgroundColor: '#ddd',
                              borderRadius: '4px',
                              width: '100%',
                            }}
                          >
                            {children}
                          </div>
                        )}
                        renderThumb={({ index, props }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: '20px',
                              width: '20px',
                              borderRadius: '50%',
                              backgroundColor: '#4caf50',
                              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
                            }}
                          ><div
                            style={{
                              position: 'absolute',
                              top: '25px',
                              left: '-10px',
                              fontSize: '12px',
                              color: '#333',
                              fontWeight: 'bold',
                            }}
                          >
                            {values}
                          </div></div>
                        )}
                      />
                    </div> */}

                    <div className="form-group mt-5 mb-3">
                      <span className="fw-bolder">Watch this video to know more about Patient Record.</span>
                      <a href="https://vimeo.com/1042224106/866c67d881" target="_blank" className="ms-5 btn btn-primary">
                        Click to watch
                      </a>
                    </div>


                    <div className="form-group">
                      <div className="row">
                        <div className="col-sm-12">
                          <label className="me-3">Insert Patient Record</label>
                          <button
                            type="button"
                            className={`btn ${ehrData ? 'btn-danger' : 'btn-dark'} ms-2`}
                            onClick={handleShowAllToggle}
                          >
                            {ehrData ? 'Disable' : 'Enable'}
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Patient File / Electronic Health Record (EHR) */}

                    {ehrData && (
                      <div>
                        <div className="form-group required">
                          <div className="row">
                            <label htmlFor="assessmentBlueprint" className="col-sm-3 control-label">
                              Patient File / Electronic Health Record (EHR):
                            </label>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              {/* Dynamically Render EHR Records */}
                              {EHRRecord && EHRRecord.length > 0 && EHRRecord.map((record, index) => (
                                <div key={record.Id} className="row align-items-center mb-3">
                                  <div className="col-sm-3">
                                    <input
                                      type="text"
                                      placeholder="Heading"
                                      className="form-control"
                                      name={`Heading`}
                                      value={record.Heading}
                                      onChange={(e) => handleChangeNew(e, "EHRRecord", index)}
                                    />
                                  </div>

                                  <div className="col-sm-8">
                                    <input
                                      type="text"
                                      placeholder="Enter the description."
                                      className="form-control"
                                      name={`Description`}
                                      value={record.Description}
                                      onChange={(e) => handleChangeNew(e, "EHRRecord", index)}
                                    />
                                  </div>
                                  <div className="col-sm-1">
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => handleDeleteEHR(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              ))}
                              <div className="row align-items-center">
                                <div className="col-sm-10">
                                  <button
                                    style={{ backgroundColor: '#304153', color: 'white' }}
                                    type="button"
                                    className="btn"
                                    onClick={handleAddNewEHR}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Physical Examination:  */}
                        <div className="form-group required">
                          <div className="row">
                            <label htmlFor="assessmentBlueprint" className="col-sm-3 control-label">
                              Physical Examination:
                            </label>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              {physicalExam && physicalExam.length > 0 && physicalExam.map((exam, index) => (
                                <div key={exam.Id} className="row align-items-center mb-3">
                                  <div className="col-12 col-sm-2">
                                    <input
                                      type="text"
                                      placeholder="Heading"
                                      className="form-control"
                                      name={`Heading`}
                                      value={exam.Heading}
                                      onChange={(e) => handleChangeNew(e, "PhysicalExam", index)}
                                    />
                                  </div>
                                  <div className="col-12 col-sm-4">
                                    <input
                                      type="text"
                                      placeholder="Enter the description."
                                      className="form-control"
                                      name={`Description`}
                                      value={exam.Description}
                                      onChange={(e) => handleChangeNew(e, "PhysicalExam", index)}
                                    />
                                  </div>
                                  {/* <div className="col-sm-2">
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => handleImageChange(e, index)} // Handle image file selection
                              />
                            </div> */}
                                  <div className="col-12 col-sm-3">
                                    <label
                                      className="btn btn-dark"
                                      style={{
                                        width: '100%',
                                        padding: '10px 20px',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        color: 'white',
                                        borderRadius: '5px',
                                      }}
                                    >
                                      <input
                                        type="file"
                                        onChange={(e) => handleImagePhyExam(e, index)}
                                        style={{ display: 'none' }}
                                      />
                                      Upload
                                    </label>
                                  </div>
                                  {exam.ImageUrl && (
                                    <div className="col-12 col-sm-2">
                                      <button
                                        style={{
                                          borderRadius: '5px',
                                        }}
                                        type="button"
                                        className="btn btn-dark"
                                        onClick={() => toggleImagePreview(index)}
                                      >
                                        {imagePreviewVisible[index] ? 'Hide' : 'Show'}
                                      </button>
                                      {/* {imagePreviewVisible[index] && (
                                  <img
                                    src={exam.ImageUrl}
                                    alt={`Physical Exam ${index + 1}`}
                                    className="img-fluid"
                                    style={{ maxWidth: '80px', height: '80px', marginTop: '5px' }}
                                  />
                                )} */}
                                    </div>
                                  )}
                                  <div className="col-12 col-sm-1">
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => handleDeletePhysicalExam(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                  {imagePreviewVisible[index] && (
                                    <img
                                      src={exam.ImageUrl}
                                      alt={`Physical Exam ${index + 1}`}
                                      className="img-fluid"
                                      style={{ width: 'auto', height: '130px', marginTop: '10px' }}
                                    />
                                  )}
                                </div>
                              ))}
                              <div className="row align-items-center">
                                <div className="col-12 col-sm-10">
                                  <button
                                    style={{ backgroundColor: '#304153', color: 'white' }}
                                    type="button"
                                    className="btn"
                                    onClick={handleAddNewPhysicalExam}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Vital Signs: */}
                        <div className="form-group required">
                          <div className="row">
                            <label htmlFor="assessmentBlueprint" className="col-sm-5 control-label">
                              Vital Signs:
                            </label>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              {/* Dynamically Render EHR Records */}
                              {vitalSign && vitalSign.length > 0 && vitalSign.map((sign, index) => (
                                <div key={sign.Id} className="row align-items-center mb-3">
                                  <div className="col-sm-3">
                                    <input
                                      type="text"
                                      placeholder="Heading"
                                      className="form-control"
                                      name={`Heading`}
                                      value={sign.Heading}
                                      onChange={(e) => handleChangeNew(e, "VitalSign", index)}
                                    />
                                  </div>
                                  <div className="col-sm-8">
                                    <input
                                      type="text"
                                      placeholder="Enter the description."
                                      className="form-control"
                                      name={`Description`}
                                      value={sign.Description}
                                      onChange={(e) => handleChangeNew(e, "VitalSign", index)}
                                    />
                                  </div>
                                  {/* {sign.ImageUrl && (
                              <div className="col-sm-12 mt-3">
                                <img src={sign.ImageUrl} alt={`Physical Exam ${index + 1}`} className="img-fluid" />
                              </div>
                            )} */}
                                  <div className="col-sm-1">
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => handleDeleteVitalSign(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>

                              ))}
                              <div className="row align-items-center">
                                <div className="col-sm-10">
                                  <button
                                    style={{ backgroundColor: '#304153', color: 'white' }}
                                    type="button"
                                    className="btn"
                                    onClick={handleAddNewVitalSign}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}





                    <hr style={{ height: "2px", color: "#000", marginTop: "30px", marginBottom: "10px" }} />
                    <h4 style={{ textAlign: "center", marginTop: "0", marginBottom: "20px", fontWeight: "800" }}>Additional Details</h4>

                    {/* About The Case */}
                    <div className="form-group row required">
                      <label
                        htmlFor="AboutTheCase"
                        className="col-sm-3 control-label"
                      >
                        About The Case
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          id="AboutTheCase"
                          className="form-control"
                          name="AboutTheCase"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.AboutTheCase}
                          placeholder="About the case ... "
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {UserRole == "Manager" ? (
                      <div></div>
                    ) : (
                      <div className="form-group row">
                        {/* <label for="horizontalFormEmail"
                                                        className="col-sm-2 control-label">Portal</label>
                                                    <div className="col-sm-4">
                                                        <select className="form-control select2" onChange={handleChangePortal} value={selectPortal}>
                                                            <option value="" >--Select--</option>
                                                            {
                                                                PortalList.map((result, i) => {
                                                                    return (
                                                                        <option value={result.id} key={result.id}>{result.portal_Name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div> */}
                      </div>
                    )}
                    <div className="row">
                      <div className="col-12 text-end">
                        {!isFinalSubmitting &&
                          <button
                            type="submit"
                            className="btn d-inline-block btn-primary"
                          >
                            Submit
                          </button>
                        }

                        {isFinalSubmitting &&
                          <button
                            class="btn d-inline-block btn-primary"
                            type="button"
                            disabled>
                            <span class="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                            <span role="status">Submitting...</span>
                          </button>
                        }
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatePatient;
